module.exports = __webpack_public_path__ + "img/icon_digital_more.041e8d9a.png";